<template>
  <v-container v-if="isExtensionClipUploadFinish" class="empty_container" fluid fill-height>
    <v-row class="empty_col" no-gutters align-self="center" justify="center">
      <v-col class="mt-8" v-if="!(this.clipList && this.clipList.length > 0 && this.isLastClip)" cols="12">
        <span class="empty_title">
          <b class="white1--text">{{ $t('titleEmpty') }}</b>
        </span>
      </v-col>
      <v-col v-else cols="12">
        <span class="empty_title">
          <b class="white1--text">{{ $t('titleLast') }}</b>
        </span>
      </v-col>
      <v-col cols="12" class="mt-2">
        <span class="empty_sub_title">
          {{ $t('msgEmpty') }}
        </span>
        <span class="empty_sub_title_kbd">
          {{ 'R' }}
        </span>
        <span class="empty_sub_title">
          {{ '.' }}
        </span>
      </v-col>
      <v-col cols="12" align="center">
        <select-record-type
          :isShowFollowUp="true"
          class="mt-5"
          @refreshData="$emit('refreshData')"
        ></select-record-type>
      </v-col>
    </v-row>
  </v-container>

  <div v-else></div>
</template>

<script>
import SelectRecordType from '@/views/meeting/component/SelectRecordType'
import { mapGetters } from 'vuex'

export default {
  components: { SelectRecordType },
  name: 'DetailEmpty',
  props: ['isSectionEmpty', 'isLoaded'],
  data() {
    return {
      // lastClip: this.$store.getters.isLastClip,
      isExtensionClipUploadFinish: this.$store.getters.isExtensionClipUploadFinish,
    }
  },

  mounted() {
    // console.log('isExtensionClipUploadFinish', this.isExtensionClipUploadFinish)
    if (!this.isExtensionClipUploadFinish) {
      this.$store.dispatch('setIsLoading', true)
    }
  },
  computed: {
    ...mapGetters(['isLastClip', 'clipList']),
    getHeight() {
      let emptyContainer = document.getElementsByClassName('empty_container')
      return emptyContainer[0].parentElement.clientWidth * 0.5625 + 85 + 'px'
    },
  },
}
</script>

<style scoped>
.empty_col {
  text-align: center;
}
.empty_col div {
  max-width: 400px !important;
}
.empty_container {
  height: calc(100% - 25px);
  width: 500px;
}
span.empty_title {
  display: block;
  font-size: 34px;
  color: var(--v-text-coloredSubText);
}
span.empty_sub_title {
  color: #69818b;
  font-size: 15px;
}
span.empty_sub_title_kbd {
  display: inline-block;
  box-sizing: border-box;
  background-color: #ccc;
  margin: 2px 0 2px 2px;
  border-radius: 4px;
  border: solid #121c20;
  border-width: 1px 1px 2px;
  color: #161d21;
  font-size: 11px !important;
  font-weight: 600 !important;
  min-width: 18px;
  text-align: center;
  letter-spacing: -1px;
  box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.1);
}

@media (max-width: 959px) {
  .empty_container {
    height: calc(100vh - 110px);
    min-width: 0px;
  }
}
</style>
